var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nameClass"},[_c('div',{staticStyle:{"background-color":"#f4f4f4","padding":"22px 14px 22px 14px","overflow-y":"scroll","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.nameHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }